import { MARKETING_KPIS } from '@/config/marketingContent';

export default function HeroKpiBand() {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[#2a2a2a] border border-[#2a2a2a]">
      {MARKETING_KPIS.map((kpi) => (
        <div key={kpi.label} className="bg-[#0a0a0a] px-4 py-4">
          <p className="text-xl md:text-2xl font-sans font-bold text-white tabular-nums">{kpi.value}</p>
          <p className="ni-label mt-1 text-white/40">{kpi.label}</p>
        </div>
      ))}
    </div>
  );
}
